import { render, staticRenderFns } from "./mobile-screen.vue?vue&type=template&id=5f2438a2&"
import script from "./mobile-screen.vue?vue&type=script&lang=ts&"
export * from "./mobile-screen.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-screen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports